import { uniqueBy } from '@debbie/common/dist/util/index.js';
export var PARSE_RESULT_TYPE;
(function (PARSE_RESULT_TYPE) {
    PARSE_RESULT_TYPE["HTML"] = "html";
    PARSE_RESULT_TYPE["TEXT"] = "text";
})(PARSE_RESULT_TYPE || (PARSE_RESULT_TYPE = {}));
export const parseText = (text, suggestions, returnType) => {
    const t = convertToDomElement(text);
    const fields = new Set(suggestions.map((suggestion) => suggestion.field));
    for (const mention of t.querySelectorAll('span[data-id]')) {
        const field = mention.getAttribute('data-id');
        if (field != null && fields.has(field)) {
            mention.replaceWith(document.createTextNode(field));
        }
    }
    if (returnType === 'text') {
        return t.innerText;
    }
    return t.innerHTML;
};
/**
 * Converts template tags like `{{creditor.name}}` into `@Creditor Name`
 * @param text
 */
export const encodeText = (text, suggestions) => {
    let t = text;
    // Properties on different entities can share a handle.
    const uniqueSuggestions = uniqueBy(suggestions, (s) => s.field);
    for (let i = 0; i < uniqueSuggestions.length; i++) {
        const suggestion = uniqueSuggestions[i];
        const re = new RegExp(suggestion.field, 'g');
        t = t.replace(re, stringBuilderToParser(suggestion.field, suggestion.label));
    }
    return t;
};
const replaceHtmlEntites = (() => {
    const translate_re = /&(nbsp|amp|quot|lt|gt);/g;
    const translate = {
        nbsp: String.fromCharCode(160),
        amp: '&',
        quot: '"',
        lt: '<',
        gt: '>',
    };
    const translator = (full, match) => {
        return translate[match];
    };
    return (s) => {
        return s.replace(translate_re, translator);
    };
})();
export const getSubjectContent = (subjectHtml) => {
    const regex = new RegExp(`(<p>){1}(.*)(</p>){1}`, 'g');
    const matches = regex.exec(subjectHtml);
    const noHTML = replaceHtmlEntites((matches && matches[2]) || subjectHtml);
    return noHTML.replace(/\n/g, '').replace(/<p>\<\/p>/g, '');
};
const stringBuilderToParser = (field, label) => {
    return `<span class="mention" data-type="mention" data-id="${field}" data-label="${label}" data-mention-suggestion-char="@">@${label}</span>`;
};
const convertToDomElement = (htmlString) => {
    const wrapper = document.createElement('div');
    wrapper.innerHTML = htmlString;
    return wrapper;
};
/*export const templateValidator = (
  content: string,
  lang: LanguageMap,
): { message: string; count: number }[] => {
  const errors: { message: string; count: number }[] = []

  const raw = convertToRaw(editorState.getCurrentContent())

  let ifCounter: number = 0
  let endIfCounter: number = 0
  let orderCounter: number = 0

  Object.values(raw.entityMap).forEach((entity: RawDraftEntity) => {
    if (entity.type === 'MENTION') {
      const key = entity.data.text
      if ('@' + lang.mentionsConditional.if === key.split(' ')[0]) {
        ifCounter++
        orderCounter++
      } else if ('@' + lang.mentionsConditional.endIf === key) {
        endIfCounter++
        if (orderCounter > 0) {
          orderCounter--
        }
      }
    }
  })

  if (ifCounter > endIfCounter) {
    errors.push({
      message:
        lang.templates.validations.missing +
        ' @' +
        lang.mentionsConditional.endIf,
      count: ifCounter - endIfCounter,
    })
  } else if (ifCounter < endIfCounter) {
    errors.push({
      message:
        lang.templates.validations.missing + ' @' + lang.mentionsConditional.if,
      count: endIfCounter - ifCounter,
    })
  }

  if (orderCounter > 0) {
    errors.push({
      message: lang.templates.validations.invalidOrder,
      count: orderCounter,
    })
  }

  return errors
}
*/
//# sourceMappingURL=templates.js.map